import React, { useState, useEffect, useCallback } from "react";
import { Dropdown, TextInput } from "hesus-ui-kit";
import { withTranslation } from "react-i18next";
import axios from "axios";
import PropTypes from "prop-types";
import { useGetMultiUserCurrenciesByCountryId } from "@hooks/useGeneralParams";
import { SellingConditionsFields } from "../../AddEditSellingPrice.Model";
import {
  CatalogContiner,
  GridRow,
  CatalogServiceOption,
  CatalogServiceOptionCount,
} from "../../AddEditSellingPrice.styled";
import "./CatalogServices.scss";

import {
  labelStyles,
  inputStyles,
  labelStylesError,
  inputStylesError,
} from "@utils/extra-style";

const CatalogServices = (props) => {
  const {
    t,
    formData,
    setFormData,
    isDisabled,
    setAllCatalogServiceList,
    setIsCurrencyChange,
    countryId,
  } = props;

  const [catalogServiceList, setCatalogServiceList] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const userCurrency = useGetMultiUserCurrenciesByCountryId(countryId);

  const fetchCatalogService = () => {
    axios
      .get(`/general/hesusCatalog?countries=[${countryId}]`)
      .then((response) => {
        const servicesList = Object.entries(response.data).map(
          (entry, index) => {
            let labelInfo =
              entry[1].hesusServices.length > 1
                ? "(" +
                  entry[1].hesusServices.length +
                  " " +
                  t("CATALOG_ENTRY_MULTIPLE_SERVICES") +
                  ")"
                : "";
            return {
              label: (
                <div>
                  <CatalogServiceOption key={"label_" + index}>
                    {entry[1].label}
                  </CatalogServiceOption>
                  <CatalogServiceOptionCount
                    className="price__icon-row"
                    key={"count_" + index}
                  >
                    {labelInfo}
                  </CatalogServiceOptionCount>
                </div>
              ),
              value: entry[1].id,
            };
          }
        );
        setCatalogServiceList(servicesList);
        setAllCatalogServiceList(response.data);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    fetchCatalogService();
  }, []);

  useEffect(() => {
    const currenciesList = Object.entries(userCurrency).map((entry) => {
      return { label: entry[1], value: entry[0] };
    });
    setCurrencies(currenciesList);
  }, []);

  const onCatalogServiceChange = (e) => {
    setFormData({
      ...formData,
      catalogService: {
        value: e.value,
        error: "",
        required: true,
      },
    });
  };

  const onLabelChange = (e) => {
    setFormData({
      ...formData,
      label: {
        value: e.target.value,
        error: "",
        required: true,
      },
    });
  };

  const onCurrencySelect = (selectedCurrency) => {
    setFormData({
      ...formData,
      currency: {
        value: selectedCurrency.value,
        error: "",
        required: true,
      },
    });
    setIsCurrencyChange(true);
  };

  return (
    <CatalogContiner className="sellingPrice-catalogService">
      <GridRow column="50% 1fr 1fr">
        <div className="catalog-name">
          <Dropdown
            id="catalog-name"
            label={t("CATALOG_ENTRY_NAME")}
            name="catalog-name"
            value={formData.catalogService.value}
            onChange={onCatalogServiceChange}
            defaultOption={t("CATALOG_ENTRY_NAME")}
            options={catalogServiceList}
            required
            disabled={isDisabled}
            labelStyles={
              formData.catalogService.error !== ""
                ? labelStylesError
                : labelStyles
            }
            inputStyles={
              formData.catalogService.error !== ""
                ? inputStylesError
                : inputStyles
            }
            containerStyles={{ marginBottom: "7px" }}
            error={formData.catalogService.error}
          />
        </div>
        {currencies.length > 1 && (
          <div className="catalog-name">
            <Dropdown
              label={t("SELLING_PRICE_CURRENCY")}
              name={SellingConditionsFields.currency}
              value={String(formData.currency.value)}
              defaultOption={t("SELECT_CURRENCY")}
              options={currencies}
              required
              disabled={isDisabled}
              onChange={onCurrencySelect}
              labelStyles={
                formData.currency.error !== "" ? labelStylesError : labelStyles
              }
              inputStyles={
                formData.currency.error !== "" ? inputStylesError : inputStyles
              }
              containerStyles={{ marginBottom: "7px" }}
              error={formData.currency.error}
            />
          </div>
        )}
      </GridRow>
      <GridRow column="1fr">
        <TextInput
          type="text"
          label={t("SELLING_PRICE_LABEL")}
          onChange={onLabelChange}
          name="exchange-rate"
          id="exchange-rate"
          value={String(formData?.label?.value) || ""}
          isFloat
          disabled={isDisabled}
          errorStyles={{ "font-style": "italic" }}
          labelStyles={
            formData.label.error !== "" ? labelStylesError : labelStyles
          }
          inputStyles={
            formData.label.error !== "" ? inputStylesError : inputStyles
          }
          containerStyles={{ marginTop: "21px" }}
          error={formData.label.error}
          placeholder={t("SELLING_PRICE_LABEL")}
        />
      </GridRow>
    </CatalogContiner>
  );
};

CatalogServices.propTypes = {
  requestId: PropTypes.number,
  isJobsite: PropTypes.bool,
  isEditMode: PropTypes.bool,
  isDisabled: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

CatalogServices.defaultProps = {
  requestId: null,
  isJobsite: false,
  isDisabled: null,
  isEditMode: null,
};

export default withTranslation()(CatalogServices);
